'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { List } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { EntityTypes } from 'AdsUI/lib/Constants';
import UILink from 'UIComponents/link/UILink';
import FilteredAndSortedCampaignReportingTable from 'AdsUI/components/campaign-reporting/FilteredAndSortedCampaignReportingTable';
import { NavMarker } from 'react-rhumb';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import H5 from 'UIComponents/elements/headings/H5';
import UIBreadcrumbs from 'UIComponents/nav/UIBreadcrumbs';
import UIButtonGroup from 'UIComponents/button/UIButtonGroup';
import UIButton from 'UIComponents/button/UIButton';
import UICardHeader from 'UIComponents/card/UICardHeader';
import AddEntityContainer from 'AdsUI/containers/campaign-details/AddEntityContainer';

const CampaignDetailsBreadcrumb = ({
  parent,
  entityType,
  network,
  onReturnToCampaign
}) => {
  if (entityType === EntityTypes.ADGROUP) {
    return /*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(UIHelpIcon, {
        title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `campaigns.campaignDetailsTable.labels.${network}.tooltip`
        }),
        tooltipPlacement: "right",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `campaigns.campaignDetailsTable.labels.${network}.${EntityTypes.ADGROUP}`
        })
      })
    });
  }

  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(UIBreadcrumbs, {
      className: "p-left-0",
      children: /*#__PURE__*/_jsx(UILink, {
        onClick: onReturnToCampaign,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `campaigns.campaignDetailsTable.labels.${network}.backToAdgroup`
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "m-top-2"
    }), /*#__PURE__*/_jsx(H5, {
      children: (entityType === EntityTypes.AD || entityType === EntityTypes.KEYWORD || entityType === EntityTypes.NEGATIVE_KEYWORD) && /*#__PURE__*/_jsx("span", {
        children: parent && parent.name
      })
    })]
  });
};

const CampaignTypeSelector = ({
  possibleTypes,
  entityType,
  network,
  onTypeChange
}) => /*#__PURE__*/_jsx(UIButtonGroup, {
  children: possibleTypes.map(type => /*#__PURE__*/_jsx(UIButton, {
    use: "tertiary-light",
    size: "small",
    active: entityType === type,
    onClick: () => onTypeChange(type),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `campaigns.campaignDetailsTable.labels.${network}.${type}`
    })
  }, type))
});

const CampaignDetailsTable = ({
  CampaignDetailsBreadcrumbComponent = CampaignDetailsBreadcrumb,
  network,
  loading,
  failed,
  columns,
  lifecycleStageLabelsByStageId,
  campaignChildren,
  entityType,
  parentType,
  parent,
  possibleTypes,
  campaignEntity,
  globalFilters,
  statusFilter,
  errorsByAdAccount,
  totals,
  hasCampaignManagement,
  parentTrackingStatus,
  onClickEntity,
  onReturnToCampaign,
  onTypeChange,
  toggleEntityStatus,
  hasWriteScope,
  hasRoiReportingScope,
  adAccount,
  adAccounts,
  onColumnReorder,
  columnDisplayLabels,
  allWorkflows
}) => /*#__PURE__*/_jsxs("div", {
  className: "campaign-details-table",
  children: [/*#__PURE__*/_jsx(FilteredAndSortedCampaignReportingTable, {
    breadcrumb: /*#__PURE__*/_jsx(CampaignDetailsBreadcrumbComponent, {
      parent: parent,
      entityType: entityType,
      network: network,
      onReturnToCampaign: onReturnToCampaign
    }),
    header: possibleTypes.length > 1 && /*#__PURE__*/_jsx(UICardHeader, {
      title: /*#__PURE__*/_jsx(CampaignTypeSelector, {
        possibleTypes: possibleTypes,
        entityType: entityType,
        network: network,
        onTypeChange: onTypeChange
      }),
      titleSize: "medium",
      toolbar: /*#__PURE__*/_jsx("div", {
        className: "display-inline-block",
        children: /*#__PURE__*/_jsx(AddEntityContainer, {
          network: network,
          adAccount: adAccount,
          parent: parent,
          campaignEntity: campaignEntity,
          entityType: entityType
        })
      })
    }),
    toggleEntityStatus: toggleEntityStatus,
    loading: loading && !failed,
    columns: columns,
    lifecycleStageLabelsByStageId: lifecycleStageLabelsByStageId,
    campaignChildren: campaignChildren || List(),
    entityType: entityType,
    adAccounts: adAccounts,
    parent: parent,
    parentType: parentType,
    parentTrackingStatus: parentTrackingStatus,
    campaignEntity: campaignEntity,
    globalFilters: globalFilters,
    onClickEntity: onClickEntity,
    hasWriteScope: hasWriteScope,
    hasRoiReportingScope: hasRoiReportingScope,
    hasCampaignManagement: hasCampaignManagement,
    onColumnReorder: onColumnReorder,
    statusFilter: statusFilter,
    showEditColumns: entityType !== EntityTypes.NEGATIVE_KEYWORD,
    showTotals: entityType !== EntityTypes.NEGATIVE_KEYWORD,
    errorsByAdAccount: errorsByAdAccount,
    totals: totals,
    columnDisplayLabels: columnDisplayLabels,
    allWorkflows: allWorkflows
  }), !loading && /*#__PURE__*/_jsx(NavMarker, {
    name: "CAMPAIGN_DETAILS_TABLE_LOADED"
  })]
});

export default CampaignDetailsTable;